<template>
  <div
    v-if="opportunityBeingVisited.training.isActive"
    id="trainings-info"
    class="container"
  >
    <div class="columns">
      <div id="trainings-box" class="column box">
        <trainings-title
          :title="trainingFormat"
          buttonText="Solicitar"
          :description="description"
          :isCardOpen="isCardOpen"
          @open-card="$emit('open-card', 'training')"
          @close-card="$emit('close-card', 'training')"
        />

        <div class="columns action-details" v-if="isCardOpen">
          <themes
            :themes="opportunityBeingVisited.training.themes"
            :specificThemes="opportunityBeingVisited.training.specificThemes"
          />

          <prerequisites
            :minPublic="opportunityBeingVisited.training.minPublic"
            :maxPublic="opportunityBeingVisited.training.maxPublic"
            :advance="opportunityBeingVisited.training.advance"
            :limitDateForRequests="opportunityBeingVisited.limitDateForRequests"
            :limitDateForActions="opportunityBeingVisited.limitDateForActions"
            :courses="opportunityBeingVisited.training.courses"
            :states="opportunityBeingVisited.training.states"
          />

          <counterparts
            :treatmentPronoun="opportunityBeingVisited.treatmentPronoun"
            :businessName="opportunityBeingVisited.businessName"
            :logosZipURL="opportunityBeingVisited.page.logosZipURL"
            action="o treinamento"
          />
        </div>
      </div>
    </div>

    <b-modal :active.sync="isRequestModalActive">
      <training-request-modal
        :minPublic="opportunityBeingVisited.training.minPublic"
        :advance="opportunityBeingVisited.training.advance"
      />
    </b-modal>
  </div>
</template>

<script>
import { descriptions } from "../../../assets/js/actions-descriptions";
import trainingsTitle from "./card/Title";
import themes from "./card/Themes";
import prerequisites from "./card/Prerequisites";
import counterparts from "./card/Counterparts";
import trainingRequestModal from "../request-modal/TrainingRequestModal";

export default {
  props: ["opportunityBeingVisited", "isCardOpen"],

  components: {
    trainingsTitle,
    themes,
    prerequisites,
    counterparts,
    trainingRequestModal
  },

  data() {
    return {
      description: "",
      isRequestModalActive: false
    };
  },

  computed: {
    trainingFormat(){
      if(this.opportunityBeingVisited.training.format == 'online'){
        return 'Treinamentos (Online)';
      } else if(this.opportunityBeingVisited.training.format == 'faceToFace'){
        return 'Treinamentos (Presencial)';
      } else {
        return 'Treinamentos (Presencial ou Online)';
      }
    }
  },

  mounted() {
    this.description = descriptions.training;
  }
};
</script>

<style scoped>
#trainings-info {
  margin-top: 3rem;
}
@media (max-width: 1023px) {
  #trainings-info {
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }
}
#trainings-box {
  background-color: rgb(242, 242, 242);
}
.action-details {
  padding: 2rem;
}
</style>
